import React from 'react';
import { Emoji } from 'emoji-mart';
import { addIndex } from 'ramda';
import { map, prop, compose, isEmpty, compact, includes, get } from 'lodash/fp';

import { ITEMS } from './Items';

export const withDomainRef = url => `${url}/?ref=producthunt`;
export const mapWithIndex = addIndex(map);
export const getItemById = index => ITEMS[index] || null;

export const getFilteredItemsByHashTags = filter => {
  const filteredItems = compose(
    compact,
    map(item => {
      const hashtags = prop('hashtags', item.product);
      return includes(filter, hashtags) && item.id;
    })
  )(ITEMS);

  if (isEmpty(filteredItems)) {
    return map(get('id'), ITEMS);
  }

  return filteredItems;
};

export const getTextByFilter = (filter, filteredList) => {
  if (filter === 'mobile') {
    return (
      <React.Fragment>
        <Emoji emoji="iphone" set="apple" size={24} /> {filteredList.length} mobilních aplikací
      </React.Fragment>
    );
  }

  if (filter === 'web') {
    return (
      <React.Fragment>
        <Emoji emoji="desktop_computer" set="apple" size={24} /> {filteredList.length} webových
        aplikací
      </React.Fragment>
    );
  }
  if (filter === 'startup') {
    return (
      <React.Fragment>
        <Emoji emoji="rocket" set="apple" size={24} /> {filteredList.length} startapů
      </React.Fragment>
    );
  }

  if (filter === 'hiring') {
    return (
      <React.Fragment>
        <Emoji emoji="male-technologist" set="apple" size={24} /> {filteredList.length} firem, které
        hledají posilu
      </React.Fragment>
    );
  }

  return (
    <div>
      <Emoji emoji="raised_hands" set="apple" size={24} /> {filteredList.length} vybraných projektů
    </div>
  );
};
